/**
 * Gets the appropriate deep link URL based on the current app configuration.
 * @param path The path to append to the deep link
 * @returns The complete deep link URL
 */
export function getAppDeepLink(path: string): string {
    const appName = environment?.appName || "sazka";
    const pathTrimmed = path.replace(/^\/+|\/+$/g, ""); // Remove leading and trailing slashes

    switch (appName) {
        case "sazkahry":
        case "sazkabet":
            return `${appName}://home/${pathTrimmed}/`;
        case "sazka":
        default:
            return `sazka://${pathTrimmed}/`;
    }
}
